<div class="p-md">
  <doka-button
    [disabled]="disabled"
    [icon]="'publish'"
    [buttonText]="'PLAN.PUBLISH_RESULT_360.SHARE_D360_BUTTON' | translate"
    [expand]="true"
    [isLoading]="isPublishing"
    (click)="publishResult()"></doka-button>
</div>
